import axios, { AxiosInstance } from "axios";
import { useAuthStore } from "../store/useAuthStore";
import { getSecureItem } from "../utils/aes";
import CryptoJS from "crypto-js";

const baseURL = process.env.REACT_APP_BASE_URL;
const digitalIdBaseURL = process.env.REACT_APP_BASE_DIGITALID_URL;
const TIMEOUT = 10000;

// helper for deterministic keys
function hashKey(key: string) {
  return CryptoJS.SHA256(key).toString();
}

function attachEsimAuthInterceptors(client: AxiosInstance) {
  client.interceptors.request.use(
    (config) => {
      const authStorage = localStorage.getItem("auth-storage");

      const username = getSecureItem("username");
      const password = getSecureItem("password");
      const apikey = getSecureItem("apikey");

      let token = null;

      if (authStorage) {
        try {
          const parsedAuth = JSON.parse(authStorage);
          token = parsedAuth.state?.token;
        } catch (error) {
          console.error("Error parsing auth storage:", error);
        }
      }

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (username && password && apikey) {
        config.headers[hashKey("username")] = username;
        config.headers[hashKey("password")] = password;
        config.headers[hashKey("apikey")] = apikey;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        useAuthStore.getState().logout();
        window.location.href = "/";
      }
      return Promise.reject(error);
    },
  );
}

export const packageClient = axios.create({
  baseURL, // Use UAT base URL for all requests by default
  timeout: TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosLoginClient = axios.create({
  baseURL: baseURL, // Use UAT base URL for all requests by default
  timeout: TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});
attachEsimAuthInterceptors(axiosLoginClient);

export const axiosClient = axios.create({
  baseURL: baseURL, // Use UAT base URL for all requests by default
  timeout: TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});

attachEsimAuthInterceptors(axiosClient);

export const digitalIdClient = axios.create({
  baseURL: digitalIdBaseURL,
  timeout: TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});
